import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { BranchesClient } from "@/features/branches/BranchesClient";
import { branchKeys, listBranches } from "@/features/branches/branches.api";

export const Route = createFileRoute("/_shell/branches")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin")) {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: BranchesScreen,
});

function BranchesScreen() {
  const branchesQuery = useQuery({ queryKey: branchKeys.list, queryFn: listBranches });
  const { session } = Route.useRouteContext();

  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Branches">
      <BranchesClient
        branches={branchesQuery.data ?? []}
        userId={session.userId}
        isFetching={branchesQuery.isFetching}
        isLoading={branchesQuery.isLoading}
      />
    </div>
  );
}
